export { default as FollowLinkArrow } from './FollowLinkArrow.svg';
export { default as AboutUsEn } from './aboutUsEn.svg';
export { default as AboutUsAr } from './aboutUsAr.svg';
export { default as SlickArrow } from './slickArrow.svg';
export * from './company-logos';
